import * as React from "react";
function XxlIcon() {
    return React.createElement("path", { d: "M12.5462 37.0539L10.9463 35.4539L22.4001 24.0001L10.9463 12.5462L12.5462 10.9463L24.0001 22.4001L35.4539 10.9463L37.0539 12.5462L25.6 24.0001L37.0539 35.4539L35.4539 37.0539L24.0001 25.6L12.5462 37.0539Z", fill: "currentColor" });
}
export default XxlIcon;
//# sourceMappingURL=Xxl.js.map